import {
	DELETE_CREDIT_LINE_ERROR,
	DELETE_CREDIT_LINE_SUCCESS,
	DELETE_CREDIT_LINE_REQUEST,
	GET_ONE_CREDIT_LINE_REQUEST,
	GET_ONE_CREDIT_LINE_SUCCESS,
	GET_ONE_CREDIT_LINE_ERROR,
	GET_ONE_CREDIT_LINE_DETAIL_REQUEST,
	GET_ONE_CREDIT_LINE_DETAIL_SUCCESS,
	GET_ONE_CREDIT_LINE_DETAIL_ERROR,
	ADD_CREDIT_LINE_REQUEST,
	ADD_CREDIT_LINE_SUCCESS,
	ADD_CREDIT_LINE_ERROR,
	UPDATE_CREDIT_LINE_REQUEST,
	UPDATE_CREDIT_LINE_SUCCESS,
	UPDATE_CREDIT_LINE_ERROR,
} from "./types";

import { BASEURL } from "../../constant/config.js";
const axios = require("axios");

export const addCreditLine = (token, object) => (dispatch) => {
	dispatch({ type: ADD_CREDIT_LINE_REQUEST });
	return axios({
		method: "POST",
		url: `${BASEURL}create/creditLine`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
		data: object,
	})
		.then((response) => {
			return dispatch({
				type: ADD_CREDIT_LINE_SUCCESS,
				payload: response?.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: ADD_CREDIT_LINE_ERROR,
				payload: error.response,
			});
		});
};

export const updateCreditLine = (token, shipHeaderId, object) => (dispatch) => {
	dispatch({ type: UPDATE_CREDIT_LINE_REQUEST });
	return axios({
		method: "PUT",
		url: `${BASEURL}update/creditLine/${shipHeaderId}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
		data: {
			dataLine: object,
		},
	})
		.then((response) => {
			return dispatch({
				type: UPDATE_CREDIT_LINE_SUCCESS,
				payload: response.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: UPDATE_CREDIT_LINE_ERROR,
				payload: error.response,
			});
		});
};

export const getOneCreditLineDetail = (token, id) => (dispatch) => {
	dispatch({ type: GET_ONE_CREDIT_LINE_DETAIL_REQUEST });

	return axios({
		method: "GET",
		url: `${BASEURL}getOne/creditLine/${id}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
	})
		.then((response) => {
			return dispatch({
				type: GET_ONE_CREDIT_LINE_DETAIL_SUCCESS,
				payload: response.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: GET_ONE_CREDIT_LINE_DETAIL_ERROR,
				payload: error.response,
			});
		});
};

export const getOneCreditLine = (token, id) => (dispatch) => {
	dispatch({ type: GET_ONE_CREDIT_LINE_REQUEST });
	return axios({
		method: "GET",
		url: `${BASEURL}getOne/getCreditLineDetail/${id}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
	})
		.then((response) => {

			return dispatch({
				type: GET_ONE_CREDIT_LINE_SUCCESS,
				payload: response.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: GET_ONE_CREDIT_LINE_ERROR,
				payload: error.response,
			});
		});
};

export const deleteCreditLine = (token, id) => (dispatch) => {
	dispatch({ type: DELETE_CREDIT_LINE_REQUEST });
	return axios({
		method: "DELETE",
		url: `${BASEURL}delete/creditLine/${id}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
	})
		.then((response) => {
			return dispatch({
				type: DELETE_CREDIT_LINE_SUCCESS,
				payload: response.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: DELETE_CREDIT_LINE_ERROR,
				payload: error.response,
			});
		});
};